exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./StdKaiXHYL1EG-Md.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./StdKaiXHYL2EG-Md.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./StdKaiXHYL3EG-Md.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./StdKaiXHYL4EG-Md.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./StdKaiXHYL5EG-Md.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./StdKaiXHYL6EG-Md.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./GologDernangSadris-Yigchen.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./himalaya.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./Jomolhari.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./MonlamUniOuChan2.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!./SambhotaUnicodeweb.css"), "");

// Module
exports.push([module.id, "/* @import \"GologDernangSadris-Drutsa.css\"; */\r\n/* @import \"GologDernangSadris-Yigchung.css\"; */\r\n\r\n/* @import \"Gurtsa.css\"; */\r\n/* @import \"MonlamUniOuChan2New.css\"; */\r\n\r\n/* @import \"pechug.css\"; */\r\n/* @import \"Yigchen.css\"; */", ""]);

